import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import {createSelector} from "reselect";
import localeStorage from "@/store/storage/localeStorage";

export interface ILocaleState {
    themeType: string,
}

const initialState: ILocaleState = {
    themeType: 'light',
};

export const localSlice = createSlice({
    name: 'local',
    initialState,
    reducers: {
        setThemeType: (state, action: PayloadAction<string>) => {
            state.themeType = action.payload;
        },
    },
});


// Action creators are generated for each case reducer function
export const {
    setThemeType,
} = localSlice.actions;

const localReducer = localSlice.reducer;

const localPersistConfig = {
    key: 'local',
    storage: localeStorage,
    whitelist: ['themeType'],
};

export const selectLocaleSelector = createSelector(
    (state) => state.local,
    (global) => global
)

export const localPersistReducer = persistReducer(localPersistConfig, localReducer)